import * as angular from 'angular';
import * as _ from 'lodash';
import UIUtilityServiceName, { UIUtilityService } from "../../services/utility/uiUtility.service";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";

let requires = [UIUtilityServiceName];

export interface CavityCorrelationGraphController {
  cavities: apsViewModels.CavityCorrelationCountSummary[];
  setCavities();
  setTopDefects();
  cavityClicked(cavityName: string): void;
}

class CavityCorrelationSummaryGraphController implements CavityCorrelationGraphController {
  uiUtilityService: UIUtilityService;
  sectionList: number[];
  cavities: apsViewModels.CavityCorrelationCountSummary[];
  cavitiesPretty: any[];
  cavitiesFront: any[];
  cavitiesMiddle: any[];
  cavitiesBack: any[];
  cavityMNR: any;
  cavityQuestion: any;
  topDefects: any;
  cavitySelected: (cavity: apsViewModels.CavityCorrelationCountSummary) => void;

  constructor(uiUtilityService: UIUtilityService) {
    this.uiUtilityService = uiUtilityService;
  }

  cavityClicked(cavityName: string) {
    let selectedCavity = _.find(this.cavities, { cavity: cavityName });
    if (selectedCavity && this.cavitySelected) {
      this.cavitySelected(selectedCavity);
    }
  }

  setTopDefects(): void {
    let topDefects = [];

    // get each top defect
    _.forEach(this.cavities, cavity => {
      if (cavity.details && cavity.details.length) {

        // get first mold number
        let moldList = cavity.moldNumbers.split(',');
        let firstMoldNumber = Number(moldList[0]) || 0;

        // get cavity details
        let cavityDetails: apsViewModels.CavityDetail = {
          cavity: cavity.cavity,
          mold: firstMoldNumber,
          defect: cavity.details[0].defect,
          rejectCount: cavity.details[0].rejectCount,
          inspectCount: cavity.inspectCount,
          rejectPercent: (cavity.details[0].rejectCount / cavity.inspectCount) * 100
        };

        // add details to top defect list
        topDefects.push(cavityDetails);
      }
    });

    // get first 5 by reject count
    topDefects = _.orderBy(topDefects, ['rejectCount'], 'desc');
    topDefects = topDefects.slice(0, 5);
    this.topDefects = topDefects;
  }

  setCavities(): void {
    this.cavitiesFront = [];
    this.cavitiesMiddle = [];
    this.cavitiesBack = [];
    this.sectionList = [];
    this.cavityMNR = {};
    this.cavityQuestion = {};

    _.forEach(this.cavities, cavity => {
      let cavityCorrelationForPercent = (cavity.rejectCount / cavity.inspectCount) * 100.0 || 0.00;
      let color = this.getCorrelationColor(cavityCorrelationForPercent);
      let section = this.getCavitySection(cavity.cavity);
      let location = this.getCavityLocation(cavity.cavity);

      let cavityForList = {
        'MoldNumbers': this.getPreviousCavities(cavity.moldNumbers),
        'MostRecentCavity': this.getMostRecentCavity(cavity.moldNumbers),
        'Cavity': cavity.cavity,
        'Inspect': cavity.inspectCount,
        'Reject': cavity.rejectCount,
        'SortValue': cavity.order,
        'Percent': `${cavityCorrelationForPercent.toFixed(2)}%`,
        'Section': section,
        'Location': location,
        'Color': color,
        'TopDefect': this.getTopDefect(cavity)
      };

      if (cavityForList.Section && this.sectionList.indexOf(cavityForList.Section) === -1) {
        this.sectionList.push(cavityForList.Section);
      }

      if (location === 'F') {
        this.cavitiesFront.push(cavityForList);
      } else if (location === 'M') {
        this.cavitiesMiddle.push(cavityForList);
      } else if (location === 'B') {
        this.cavitiesBack.push(cavityForList);
      } else if (cavity.cavity === 'M+U') {
        this.cavityMNR = cavityForList;
      } else if (cavity.cavity === '?') {
        this.cavityQuestion = cavityForList;
      }
    });
  }

  getPreviousCavities(moldNumbers: string): string {
    const separator = ", ";
    if (!moldNumbers || moldNumbers.indexOf(separator) < 0) { 
      return "";
    }
    let split = moldNumbers.split(separator);
    split.reverse().pop();
    return split.join(separator) + separator;
  }

  getMostRecentCavity(moldNumbers: string): string{
    let mostRecentMold = moldNumbers;
    if (moldNumbers && moldNumbers.length > 0 && moldNumbers.indexOf(", ") > 0) {
      let split = moldNumbers.split(", ");
      return split[0];
    }
    return mostRecentMold;
  }

  getCorrelationColor(effeciencyPercent: number) {
    let color = '000000';
    if (effeciencyPercent || effeciencyPercent === 0.0) {
      color = this.uiUtilityService.getCavityCorrelationColor(effeciencyPercent) + 'A0';
    }
    return color;
  }

  getTopDefect(cavity: apsViewModels.CavityCorrelationCountSummary) {
    let topDefect = '';
    if (cavity.details && cavity.details.length) {
      topDefect = cavity.details[0].defect;
    } else if (cavity.rejectCount && cavity.details.length === 0) {
      topDefect = 'Unmapped Defect';
    }
    return topDefect;
  }

  getCavityLocation(cavity: string) {
    var location = cavity.charAt(cavity.length - 1);
    if (location === 'F' || location === 'M' || location === 'B') {
      return location;
    }
    return null;
  }

  getCavitySection(cavity: string) {
    let section = parseInt(cavity, 10);
    return section;
  }
}

export default angular.module('aps.controller.cavityCorrelationSummaryGraph', requires)
  .controller('CavityCorrelationSummaryGraphCtrl', CavityCorrelationSummaryGraphController)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/cavityCorrelationSummaryGraph.controller.ts